/* eslint-disable max-len */
/* Note: this file is generated by "npm run template", please dont modify this file directly */
/* -- instead, you should modify "static-files/gant-legacy/.umirc.ts" and run "npm run template" */
import { ResultFile } from "@gant-lowcode/lowcode-types";

export default function getFile(): [string[], ResultFile] {
  return [
    ["."],
    {
      name: ".umirc",
      ext: "ts",
      content:
        "import { defineConfig } from 'umi';\n\nexport default defineConfig({\n  nodeModulesTransform: {\n    type: 'none',\n  },\n  routes: [\n    { path: '/', component: '@/pages/index' },\n  ],\n  fastRefresh: {},\n});\n",
    },
  ];
}
